<template>
<div class="ChargeOffList spackage bgc padding-20 box-shadow">
    <div class="table_box">
        <el-table :data="chargeOffListData" style="width: 100%">
            <el-table-column prop="orderno" label="订单号"></el-table-column>
            <el-table-column label="用户名称">
                <template slot-scope="scope">
                    <div class="user_info_box">
                        <img :src="scope.row.customericonurl" alt="">
                        <span>{{scope.row.customername}}</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="ordermoney" label="订单金额 " align='center'></el-table-column>
            <el-table-column prop="ordertime" label="订单时间 " align='center'></el-table-column>
            <el-table-column label="核销状态" align='center'>
                <template slot-scope="scope">
                    <span :class="scope.row.ischek === 1 ? 'yhx' : 'dhx'">{{scope.row.ischekname}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="checktime" label="核销时间 " align='center'></el-table-column>
            <el-table-column prop="checkusername" label="核销人 " align='center'></el-table-column>
        </el-table>
        <page :total="total" ref="page" @getList="getChargeOffList"></page>
    </div>
</div>
</template>

<script>
import Page from 'base/page/page'
import {mapGetters, mapActions} from 'vuex'
import {getEventCheckOrderList} from 'api/taskToolsApi2'
export default {
    name: 'ChargeOffList',
    data() {
        return {
            total: 0,
            chargeOffListData: [
                {
                    orderno: '122933741832',
                    username: 'Joseph Brown',
                    ordermoney: '¥12129.00',
                    ordertime: '2019-05-20 18:12:21',
                    statustext: '已核销',
                    status: 1,
                    hxtime: '2019-05-20 18:12:21',
                    hxrname: '何杰',
                },
                {
                    orderno: '122933741832',
                    username: 'Joseph Brown',
                    ordermoney: '¥12129.00',
                    ordertime: '2019-05-20 18:12:21',
                    statustext: '已核销',
                    status: 1,
                    hxtime: '2019-05-20 18:12:21',
                    hxrname: '何杰',
                },
                {
                    orderno: '122933741832',
                    username: 'Joseph Brown',
                    ordermoney: '¥12129.00',
                    ordertime: '2019-05-20 18:12:21',
                    statustext: '待核销',
                    status: 0,
                    hxtime: '2019-05-20 18:12:21',
                    hxrname: '何杰',
                },
                {
                    orderno: '122933741832',
                    username: 'Joseph Brown',
                    ordermoney: '¥12129.00',
                    ordertime: '2019-05-20 18:12:21',
                    statustext: '待核销',
                    status: 0,
                    hxtime: '2019-05-20 18:12:21',
                    hxrname: '何杰',
                },
                {
                    orderno: '122933741832',
                    username: 'Joseph Brown',
                    ordermoney: '¥12129.00',
                    ordertime: '2019-05-20 18:12:21',
                    statustext: '待核销',
                    status: 0,
                    hxtime: '2019-05-20 18:12:21',
                    hxrname: '何杰',
                },
                {
                    orderno: '122933741832',
                    username: 'Joseph Brown',
                    ordermoney: '¥12129.00',
                    ordertime: '2019-05-20 18:12:21',
                    statustext: '待核销',
                    status: 0,
                    hxtime: '2019-05-20 18:12:21',
                    hxrname: '何杰',
                },
                {
                    orderno: '122933741832',
                    username: 'Joseph Brown',
                    ordermoney: '¥12129.00',
                    ordertime: '2019-05-20 18:12:21',
                    statustext: '已核销',
                    status: 1,
                    hxtime: '2019-05-20 18:12:21',
                    hxrname: '何杰',
                },
                {
                    orderno: '122933741832',
                    username: 'Joseph Brown',
                    ordermoney: '¥12129.00',
                    ordertime: '2019-05-20 18:12:21',
                    statustext: '已核销',
                    status: 1,
                    hxtime: '2019-05-20 18:12:21',
                    hxrname: '何杰',
                },
                {
                    orderno: '122933741832',
                    username: 'Joseph Brown',
                    ordermoney: '¥12129.00',
                    ordertime: '2019-05-20 18:12:21',
                    statustext: '待核销',
                    status: 0,
                    hxtime: '2019-05-20 18:12:21',
                    hxrname: '何杰',
                }
            ]
        }
    },
    mounted() {
        this.getChargeOffList()
    },
    methods: {
        // 获取核销列表数据
        getChargeOffList() {
            // this.$message.success(`当前页数：${this.page.page}`)
            this.setLoading(true)
            var params = {
                eventinnerid: this.$route.query.eventinnerid
            }
            getEventCheckOrderList({
                data: Object.assign({}, params, this.page),
                success: data => {
                    this.setLoading(false)
                    this.chargeOffListData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'page'
        ])
    },
    components: {
        Page
    }
}
</script>

<style lang="scss" type="text/scss">
.ChargeOffList {
    // padding-bottom: 100px;
    .table_box{
        .el-table__empty-block {
            min-height: 500px;
        }
        // .el-table th>.cell {
        //     font-weight: bold!important;
        //     white-space: nowrap;
        //     font-size: 16px;
        // }
        .user_info_box {
            display: flex;
            align-items: center;
            img{
                width: 50px;
                height: 50px;
                border-radius: 50%;
                margin-right: 10px;
            }
        }
        .yhx {
            color: #67C23A;
        }
        .dhx {
            color: #E6A23C;
        }
    }
}
</style>